import { useEffect, useState } from "react";
import { updateBannersForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import { FiUploadCloud } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";

export default function EditBannersUi({ bannerData }) {

    const nav = useNavigate();
    const {bannerId} = useParams();
    const [imagEn, setImageEn] = useState(null);
    const [imagAr, setImageAr] = useState(null);
    const [isActive, setIsActive] = useState(true);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {
        setImageEn(bannerData.banner_en);
        setImageAr(bannerData.banner_ar);
        setIsActive(bannerData.active)
    }, [bannerData])

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
            formData.append("isActive", isActive ? "true" : "false");
        const result = await updateBannersForm(bannerId, formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    const handleImageChangeEn = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImageEn(URL.createObjectURL(file));
        }
    };
    const handleImageChangeAr = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImageAr(URL.createObjectURL(file));
        }
    };

    const handleDeleteImageEn = () => {
        setImageEn(null);
    };
    const handleDeleteImageAr = () => {
        setImageAr(null);
    };


    if (Object.entries(bannerData).length < 1) {
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-6 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "link" : "الرابط "} </label>
                    <input
                        type="text"
                        defaultValue={bannerData.link}
                        name="link"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter link of image" : "أدخل الرابط "}
                    />
                </div>
                <div className="mb-4 ">
                    <label className="block text-white mb-4">
                        {currentLang === "en" ? "Active Status" : "حالة التفعيل"}
                    </label>
                    <div className="flex items-center gap-3">
                        <div
                            onClick={() => setIsActive(!isActive)}
                            className={`relative w-14 h-7 rounded-full cursor-pointer transition
                            ${isActive ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
                        >
                            <span
                            className={`w-5 h-5 mt-1 bg-white rounded-full shadow-md block
                                transform transition
                                ${isActive ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                            />
                        </div>
                        <span className="text-white text-sm">
                            {isActive
                            ? currentLang === "en" ? "Active" : "مفعل"
                            : currentLang === "en" ? "Inactive" : "غير مفعل"}
                        </span>
                    </div>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 w-full">
                {/* القسم الأول: الصورة العربية */}
                <div className="flex-1 w-full">
                    <label className="block text-white mb-4 font-medium">
                        {currentLang === "en" ? "Photo for Arabic" : "الصورة للغة العربية"}
                    </label>
                    
                    {/* تمت إزالة div التوسيط وإضافة w-full للكارد */}
                    <div className="w-full bg-thirdly p-6 rounded-2xl border-2 border-dashed border-gray-200">
                        <div className="relative group w-full">
                            <div className={`flex flex-col items-center justify-center h-48 w-full ${!imagAr ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                                {!imagAr ? (
                                    <>
                                        <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                                        <span className="text-sm text-white group-hover:text-secondary transition-colors">
                                            {currentLang === "en" ? "Click to upload a photo" : "انقر لرفع الصورة"}
                                        </span>
                                    </>
                                ) : (
                                    <div className="relative w-full h-full">
                                        {/* استخدام w-full للصورة لتملأ الإطار */}
                                        <img src={imagAr} alt="الصورة العربية" className="w-full h-full object-cover rounded-xl" />
                                        <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImageAr}>
                                            <MdOutlineDeleteOutline className="w-5 h-5" />
                                        </button>
                                    </div>
                                )}
                            </div>
                            <input type="file" name="banner_ar" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChangeAr} required />
                        </div>
                    </div>
                </div>

                {/* القسم الثاني: الصورة الإنجليزية */}
                <div className="flex-1 w-full">
                    <label className="block text-white mb-4 font-medium">
                        {currentLang === "en" ? "Photo for English" : "الصورة للغة الإنجليزية"}
                    </label>

                    <div className="w-full bg-thirdly p-6 rounded-2xl border-2 border-dashed border-gray-200">
                        <div className="relative group w-full">
                            <div className={`flex flex-col items-center justify-center h-48 w-full ${!imagEn ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                                {!imagEn ? (
                                    <>
                                        <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                                        <span className="text-sm text-white group-hover:text-secondary transition-colors">
                                            {currentLang === "en" ? "Click to upload a photo" : "انقر لرفع الصورة"}
                                        </span>
                                    </>
                                ) : (
                                    <div className="relative w-full h-full">
                                        <img src={imagEn} alt="الصورة الانجليزية" className="w-full h-full object-cover rounded-xl" />
                                        <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImageEn}>
                                            <MdOutlineDeleteOutline className="w-5 h-5" />
                                        </button>
                                    </div>
                                )}
                            </div>
                            <input type="file" name="banner_en" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChangeEn} required />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};